import { render, staticRenderFns } from "./qaList.vue?vue&type=template&id=77236d92&"
import script from "./qaList.vue?vue&type=script&lang=js&"
export * from "./qaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports